import { useEffect, useRef } from "react"
import {
  StyledInput,
  StyledIconBox,
  StyledSearchInput,
  CloseIconBox,
} from "./styled"
import BigSearchIcon from "components/Icons/BigSearchIcon"

const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.28033 6.21967C6.98744 5.92678 6.51256 5.92678 6.21967 6.21967C5.92678 6.51256 5.92678 6.98744 6.21967 7.28033L10.9393 12L6.21967 16.7197C5.92678 17.0126 5.92678 17.4874 6.21967 17.7803C6.51256 18.0732 6.98744 18.0732 7.28033 17.7803L12 13.0607L16.7197 17.7803C17.0126 18.0732 17.4874 18.0732 17.7803 17.7803C18.0732 17.4874 18.0732 17.0126 17.7803 16.7197L13.0607 12L17.7803 7.28033C18.0732 6.98744 18.0732 6.51256 17.7803 6.21967C17.4874 5.92678 17.0126 5.92678 16.7197 6.21967L12 10.9393L7.28033 6.21967Z"
        fill="#667085"
      />
    </svg>
  )
}

interface IProps {
  value?: string | null
  onChange?: (value: string) => void
  placeholder?: string
  disabled?: boolean
  onFocus?: () => void
  onBlur?: () => void
  onClose?: () => void
  onSearch?: (value: string) => void
  visible?: boolean
  readOnly?: boolean
}

const SearchAutocomplete = (props: IProps) => {
  const {
    placeholder,
    value,
    onChange,
    disabled,
    onFocus,
    onBlur,
    onClose,
    onSearch,
    visible,
    readOnly,
  } = props

  const inputRef = useRef<HTMLInputElement>(null)
  const lastSearchTime = useRef<number>(0)

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        inputRef.current?.focus()
      }, 100)
    }
  }, [visible])

  const handleChange = (value: string) => {
    if (!disabled) {
      onChange?.(value)
    }
  }

  const handleSearch = (searchValue: string) => {
    const now = Date.now()
    if (now - lastSearchTime.current < 200) {
      return
    }
    lastSearchTime.current = now
    onSearch?.(searchValue)
  }

  return (
    <StyledSearchInput>
      <StyledIconBox>
        <BigSearchIcon />
      </StyledIconBox>

      <StyledInput
        ref={inputRef}
        onKeyDown={(e) => {
          if (e.key === "Enter" && value) {
            handleSearch(value)
          }
        }}
        readOnly={readOnly}
        onBlur={onBlur}
        onFocus={onFocus}
        disabled={disabled}
        min={0}
        placeholder={placeholder}
        value={value ?? ""}
        onChange={(e) => {
          let val: any = e.target.value
          handleChange(val)
        }}
        style={{ paddingRight: "16px" }}
      />
      {visible && (
        <CloseIconBox onClick={onClose}>
          <CloseIcon />
        </CloseIconBox>
      )}
    </StyledSearchInput>
  )
}

export default SearchAutocomplete
